import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
} from "react";

const DashMedidasSectionOrderContext = createContext(null);

export { DashMedidasSectionOrderContext };

export const useDashMedidasSectionDragHandle = (sectionId) => {
  const ctx = useContext(DashMedidasSectionOrderContext);
  if (!ctx || !sectionId || !ctx.isSortableSection(sectionId)) {
    return null;
  }
  return ctx.getDragHandleProps(sectionId);
};

export const DashMedidasSectionOrderProvider = ({
  children,
  sortableSectionIds,
}) => {
  const dragStartHandlersRef = useRef({});

  const registerDragStart = useCallback((sectionId, handler) => {
    dragStartHandlersRef.current[sectionId] = handler;
    return () => {
      delete dragStartHandlersRef.current[sectionId];
    };
  }, []);

  const isSortableSection = useCallback(
    (sectionId) => sortableSectionIds.includes(sectionId),
    [sortableSectionIds]
  );

  const getDragHandleProps = useCallback(
    (sectionId) => ({
      className: "dash-section-card__drag-handle",
      role: "button",
      tabIndex: 0,
      "aria-label": "Arrastar seção para reordenar",
      onPointerDown: (event) => {
        event.stopPropagation();
        dragStartHandlersRef.current[sectionId]?.(event);
      },
      onClick: (event) => event.stopPropagation(),
      onKeyDown: (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.stopPropagation();
        }
      },
    }),
    []
  );

  const value = useMemo(
    () => ({
      registerDragStart,
      getDragHandleProps,
      isSortableSection,
    }),
    [registerDragStart, getDragHandleProps, isSortableSection]
  );

  return (
    <DashMedidasSectionOrderContext.Provider value={value}>
      {children}
    </DashMedidasSectionOrderContext.Provider>
  );
};
